export const TWO_FACTOR_TIMEOUT_SECONDS = (import.meta as any).env
  ?.VITE_TWO_FACTOR_TIMEOUT_SECONDS
  ? parseInt((import.meta as any).env?.VITE_TWO_FACTOR_TIMEOUT_SECONDS, 10)
  : 120;

if (isNaN(TWO_FACTOR_TIMEOUT_SECONDS) || TWO_FACTOR_TIMEOUT_SECONDS <= 0) {
  console.warn(
    'VITE_TWO_FACTOR_TIMEOUT_SECONDS deve ser um número positivo. Usando valor padrão: 120 segundos'
  );
}
